import React, { useMemo } from 'react';
import { Column } from 'react-table';
import { TableContent } from '../../../../manager/components/TableContent';

type Props = {
  categories: string[];
  turnoverRates: number[];
};

type TableItem = {
  id: string;
  [key: string]: any;
};

export const EmployeeTurnoverRateTable: React.FC<Props> = ({
  categories,
  turnoverRates,
}) => {
  const columns: Column[] = useMemo(() => {
    return categories.map((category, index) => ({
      Header: category,
      accessor: `month${index}`,
    }));
  }, [categories]);

  const data = useMemo(() => {
    const rowData: TableItem = { id: 'turnoverRates' };

    turnoverRates.forEach((rate, index) => {
      rowData[`month${index}`] = rate + '%';
    });
    return [rowData];
  }, [turnoverRates]);

  return <TableContent columns={columns} data={data} />;
};
